import { getBogusVersion } from '@/api/get-bogus-version'
import logger from '@/utils/logger'

const SEPARATOR = '|'
export const BOGUS_TOKEN_SERVICE_ERROR_CODE = 499

class BogusTokenService {
  private versionPromise: Promise<string> | null

  constructor() {
    this.versionPromise = null
  }

  init(version: string): void {
    this.versionPromise = Promise.resolve(version)
  }

  invalidateVersion(): void {
    this.versionPromise = getBogusVersion()
  }

  async generate(
    url: string,
    body?: Record<string, unknown> | Record<string, unknown>[],
  ): Promise<string> {
    if (this.versionPromise === null) {
      logger.error('BogusTokenService is not initialized')

      return ''
    }

    const version = await this.versionPromise

    let bodyString = ''

    if (body && !(body instanceof FormData)) {
      bodyString = JSON.stringify(body)
    }

    const message = [url, navigator.userAgent, bodyString].join(SEPARATOR)

    const { encrypt_with_salt } = await import('@ikala/bogus')

    return encrypt_with_salt(message, version)
  }
}

export const bogusTokenService = new BogusTokenService()
